import { z } from "zod";
import { BaseConfigurationsOutputItemWithColorSchema } from "@/Schemas/Configurations/BaseConfigurationsOutputItem";

export const ConfigurationsStateOutputItemSchema = BaseConfigurationsOutputItemWithColorSchema.extend({
    description: z.string(),
    icon: z.string(),
    common: z.boolean(),
});

export type ConfigurationsStateOutputItem = z.infer<typeof ConfigurationsStateOutputItemSchema>;

export const ConfigurationsStateOutputSchema = z.object({
    masterItems: z.array(BaseConfigurationsOutputItemWithColorSchema),
    items: z.array(ConfigurationsStateOutputItemSchema),
}).transform((data) => ({
    ...data,
    commonItems: data.items.filter((item) => item.common),
}));

export type ConfigurationsStateOutput = z.infer<typeof ConfigurationsStateOutputSchema>;